import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTheme } from '../utils/ThemeContext';
import './Header.css';

const Header = ({ onSearch }) => {
    const [searchQuery, setSearchQuery] = useState('');
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const { theme, toggleTheme } = useTheme();
    const navigate = useNavigate();

    const handleSearch = (e) => {
        e.preventDefault();
        if (searchQuery.trim()) {
            onSearch(searchQuery);
            setIsMenuOpen(false);
        }
    };

    const handleGenreClick = (genre) => {
        onSearch(genre);
        setIsMenuOpen(false);
    };

    return (
        <header className="header">
            <div className="container">
                <div className="header-content">
                    <Link to="/" className="logo">
                        <img
                            src="./som movies free.png"
                            alt="MovieHub Logo"
                            className="logo-image"
                            onError={(e) => {
                                e.target.style.display = 'none';
                                e.target.parentElement.classList.add('fallback-logo');
                            }}
                        />
                    </Link>

                    <div className="mobile-menu-toggle" onClick={() => setIsMenuOpen(!isMenuOpen)}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d={isMenuOpen ? "M18 6L6 18M6 6l12 12" : "M3 12h18M3 6h18M3 18h18"} />
                        </svg>
                    </div>

                    <div className={`nav-wrapper ${isMenuOpen ? 'open' : ''}`}>
                        <nav className="nav">
                            <Link to="/" className="nav-link" onClick={() => setIsMenuOpen(false)}>Home</Link>

                            <div className="dropdown-container">
                                <button className="nav-link dropdown-trigger">
                                    Browse
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="chevron">
                                        <path d="M6 9l6 6 6-6" />
                                    </svg>
                                </button>
                                <div className="mega-menu">
                                    <div className="mega-menu-content">
                                        <div className="mega-column">
                                            <h3>Genres</h3>
                                            <button onClick={() => handleGenreClick('movie')} className="mega-link">
                                                <span className="icon" style={{ color: '#4a90e2' }}>
                                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                        <rect x="2" y="2" width="20" height="20" rx="2.18" ry="2.18" />
                                                        <line x1="7" y1="2" x2="7" y2="22" />
                                                        <line x1="17" y1="2" x2="17" y2="22" />
                                                        <line x1="2" y1="12" x2="22" y2="12" />
                                                        <line x1="2" y1="7" x2="7" y2="7" />
                                                        <line x1="2" y1="17" x2="7" y2="17" />
                                                        <line x1="17" y1="17" x2="22" y2="17" />
                                                        <line x1="17" y1="7" x2="22" y2="7" />
                                                    </svg>
                                                </span>
                                                Movies
                                            </button>
                                            <button onClick={() => handleGenreClick('series')} className="mega-link">
                                                <span className="icon" style={{ color: '#50e3c2' }}>
                                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                        <rect x="2" y="7" width="20" height="15" rx="2" ry="2" />
                                                        <polyline points="17 2 12 7 7 2" />
                                                    </svg>
                                                </span>
                                                Series
                                            </button>
                                            <button onClick={() => handleGenreClick('drama')} className="mega-link">
                                                <span className="icon" style={{ color: '#f5a623' }}>
                                                    {/* Smiley Face for Drama */}
                                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                        <circle cx="12" cy="12" r="10" />
                                                        <path d="M8 14s1.5 2 4 2 4-2 4-2" />
                                                        <line x1="9" y1="9" x2="9.01" y2="9" />
                                                        <line x1="15" y1="9" x2="15.01" y2="9" />
                                                    </svg>
                                                </span>
                                                Drama
                                            </button>
                                        </div>
                                        <div className="mega-column">
                                            <h3>Collections</h3>
                                            <button onClick={() => handleGenreClick('horror')} className="mega-link">
                                                <span className="icon" style={{ color: '#bd10e0' }}>
                                                    {/* Ghost for Horror */}
                                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                        <path d="M9 22v-3.36a10 10 0 1 1 6 0V22" />
                                                        <path d="M8 13h.01" />
                                                        <path d="M16 13h.01" />
                                                        <path d="M12 17a2 2 0 0 0 0-4" />
                                                    </svg>
                                                </span>
                                                Horror
                                            </button>
                                            <button onClick={() => handleGenreClick('american')} className="mega-link">
                                                <span className="icon" style={{ color: '#4a4a4a' }}>
                                                    {/* Star for American */}
                                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                                    </svg>
                                                </span>
                                                American
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Link to="/contact" className="nav-link" onClick={() => setIsMenuOpen(false)}>Contact</Link>

                            <Link to="/favorites" className="nav-link icon-link" onClick={() => setIsMenuOpen(false)} aria-label="Favorites">
                                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ color: '#e50914' }}>
                                    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                                </svg>
                            </Link>
                        </nav>

                        <div className="header-actions">
                            <form onSubmit={handleSearch} className="search-form">
                                <div className="search-container">
                                    <input
                                        type="text"
                                        placeholder="Search..."
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                        className="search-input"
                                    />
                                    <button type="submit" className="search-btn" aria-label="Search">
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                            <circle cx="11" cy="11" r="8" />
                                            <path d="m21 21-4.35-4.35" />
                                        </svg>
                                    </button>
                                </div>
                            </form>

                            <button onClick={toggleTheme} className="theme-toggle" aria-label="Toggle theme">
                                {theme === 'dark' ? (
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <circle cx="12" cy="12" r="5" />
                                        <line x1="12" y1="1" x2="12" y2="3" />
                                        <line x1="12" y1="21" x2="12" y2="23" />
                                        <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
                                        <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
                                        <line x1="1" y1="12" x2="3" y2="12" />
                                        <line x1="21" y1="12" x2="23" y2="12" />
                                        <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
                                        <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
                                    </svg>
                                ) : (
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
                                    </svg>
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;
